var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.8461C22.647 28.8461 28.8461 22.647 28.8461 15C28.8461 7.35294 22.647 1.15381 15 1.15381C7.35294 1.15381 1.15381 7.35294 1.15381 15C1.15381 22.647 7.35294 28.8461 15 28.8461Z",
    fill: "#FF9D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8327 9.47778H10.1675C9.02353 9.47778 8.09595 10.4054 8.09595 11.5493V18.4534C8.09595 19.5974 9.02353 20.525 10.1675 20.525H19.8327C20.9767 20.525 21.9042 19.5974 21.9042 18.4534V11.5466C21.9042 10.4027 20.9767 9.47778 19.8327 9.47778ZM19.5515 10.857L15.4896 14.9162C15.2218 15.1866 14.7837 15.1893 14.5133 14.9189L14.5106 14.9162L10.4487 10.857H19.5515ZM20.525 18.4534C20.525 18.8348 20.2167 19.143 19.8354 19.143H10.1675C9.78615 19.143 9.47786 18.8348 9.47786 18.4534V11.8305L13.5371 15.8897C14.3456 16.6983 15.6545 16.6983 16.4658 15.8897L20.525 11.8305V18.4534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.5d2f915c211b956a8fb79bf387e0e336.svg";
export { ForwardRef as ReactComponent };